import React from "react";

export const GenreIcon = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 60 60"
      version="1.1"
      id="svg_resize"
    >
      <title>Shape</title>
      <desc>Created with Sketch.</desc>
      <defs />
      <g
        id="Самое-актуальное-"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Web_Search_genre-Stars"
          transform="translate(-102.000000, -284.000000)"
          fillRule="nonzero"
          fill="#98D8A6"
        >
          <g id="Group-5" transform="translate(42.000000, 192.000000)">
            <g id="Жанр" transform="translate(0.000000, 62.000000)">
              <path
                d="M82.4280197,64.2650799 C82.4280197,64.2650799 94.339653,57.1183914 101.045967,59.9414062 C102.436056,57.8230798 103.805511,55.5412531 105.146258,53.2117668 C98.5856136,51.6044628 89.9039515,53.0509579 89.9039515,53.0509579 C89.9039515,53.0509579 101.013559,46.3855747 107.815192,48.4719413 C109.178928,46.0125968 110.505097,43.5867822 111.784279,41.328617 C106.365669,40.9624796 101.118073,41.8369481 101.118073,41.8369481 C101.118073,41.8369481 108.077152,37.6616358 114.351726,36.9542561 C116.325616,33.7501892 118.157986,31.237466 119.808015,30 C87.0421361,30 67.4760439,67.3799954 60,89.8080151 L63.7379659,89.8080151 L74.9519757,71.1180734 C74.9519757,71.1180734 78.6899416,74.8560393 89.9039515,71.1180734 C92.5598775,70.2326152 95.2159158,67.7741678 97.8221638,64.4635679 C91.2449228,62.7958203 82.4280197,64.2650799 82.4280197,64.2650799 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
